/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { clearKpisData, fetchKpis } from 'state/actions/kpis';
import { useParams, Redirect } from 'react-router-dom';
import SelectField from 'components/Common/SelectField';
import Table from 'components/Table';
import { fetchProducts } from 'state/actions/products';
import { fetchPositions } from 'state/actions/positions';

const Home = () => {
  const { actId } = useParams();
  const {
    activationsList,
    loading,
    productsList,
    productsLoading,
    positionsCount,
    positionsLoading,
    isAdmin,
    userID,
  } = useSelector(
    (state) => ({
      isAdmin: state.auth.userData.isAdmin,
      userID: state.auth.userData.id,
      activationsList: state.kpis.data,
      productsList: state.products.data,
      productsLoading: state.products.loading,
      positionsCount: state.positions.data.length,
      positionsLoading: state.positions.loading,
      error: state.kpis.error,
      loading: state.kpis.loading,
    }),
    shallowEqual
  );
  const dispatch = useDispatch();

  const [groupBy, setGroupBy] = useState({ label: 'Nom', value: 'name' });
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    dispatch(fetchKpis(null, actId));
    dispatch(fetchPositions());
    dispatch(fetchProducts());
    return () => dispatch(clearKpisData());
  }, [dispatch]);

  useEffect(() => {
    if (
      !loading &&
      activationsList.positions &&
      activationsList.positions.length > 0
    ) {
      if (groupBy.value) {
        const reduced = activationsList.positions.reduce((m, pos) => {
          const p = pos.position;
          if (p) {
            const existsPos = m && m.find((f) => f.name === p[groupBy.value]);
            if (!existsPos) {
              return [
                ...m,
                {
                  name: p[groupBy.value],
                  products: pos.products.map((pp) => ({
                    ...pp,
                    price: parseFloat(pp.product.price),
                  })),
                  calcul: {
                    totalProducts: pos.totalProducts || 0,
                    totalContacts: pos.totalContacts || 0,
                    totalSuccessContacts: pos.totalSuccessContacts || 0,
                    count: 1,
                  },
                },
              ];
            }
            existsPos.products.map((prod) => {
              prod.quantity += parseInt(
                (pos.products.find((pp) => pp.id === prod.id) || {}).quantity ||
                  0
              );
              prod.price += parseInt(
                (
                  pos.products.find((pp) => pp.id === prod.id || {}).product ||
                  {}
                ).price || 0
              );
            });
            existsPos.calcul.totalProducts += pos.totalProducts;
            existsPos.calcul.totalContacts += pos.totalContacts;
            existsPos.calcul.totalSuccessContacts += pos.totalSuccessContacts;
            existsPos.calcul.count += 1;
            return m;
          }
          return m;
        }, []);
        setPositions(reduced);
      }
    }
  }, [loading, activationsList, groupBy]);

  const actContactsColumns = [
    {
      Header: groupBy.label,
      Cell: ({ row }) => row.original.name || '----',
    },
    {
      Header: 'Nombre POS',
      Cell: ({ row }) => row.original.calcul.count,
    },
    {
      Header: 'Ventes',
      Cell: ({ row }) => row.original.calcul.totalProducts,
    },
    {
      Header: 'Nombre de contact',
      Cell: ({ row }) => row.original.calcul.totalContacts,
    },
    {
      Header: 'Nombre de contact réussi',
      Cell: ({ row }) => row.original.calcul.totalSuccessContacts,
    },
    {
      Header: 'Coût opération',
      Cell: ({ row }) => {
        return (
          <small className="has-text-grey is-abbr-like">
            {row.original.products.reduce(
              (acc, actp) => acc + actp.quantity * actp.price,
              0
            )}
          </small>
        );
      },
    },
    {
      Header: 'Cost per contact',
      Cell: ({ row }) => {
        return (
          <small className="has-text-grey is-abbr-like">
            {(row.original.calcul.totalContacts
              ? row.original.products.reduce(
                  (acc, actp) => acc + actp.quantity * actp.price,
                  0
                ) / row.original.calcul.totalContacts
              : 0
            ).toFixed(2)}
          </small>
        );
      },
    },
    {
      Header: 'Cost per succ. contact',
      Cell: ({ row }) => {
        return (
          <small className="has-text-grey is-abbr-like">
            {(row.original.calcul.totalSuccessContacts
              ? row.original.products.reduce(
                  (acc, actp) => acc + actp.quantity * actp.price,
                  0
                ) / row.original.calcul.totalSuccessContacts
              : 0
            ).toFixed(2)}
          </small>
        );
      },
    },
  ];

  const actProductsQuantityColumns = [
    {
      Header: groupBy.label,
      Cell: ({ row }) => row.original.name || '----',
    },
    ...(!productsLoading
      ? productsList.map((p) => ({
          Header: p.name,
          Cell: ({ row }) => (
            <span>
              {(row.original.products.find((actp) => actp.id === p.id) || {})
                .quantity || 0}
            </span>
          ),
        }))
      : []),
  ];

  const actProductsPriceColumns = [
    {
      Header: groupBy.label,
      Cell: ({ row }) => row.original.name || '----',
    },
    ...(!productsLoading
      ? productsList.map((p) => ({
          Header: p.name,
          Cell: ({ row }) => (
            <span>
              {(row.original.products.find((actp) => actp.id === p.id) || {})
                .price || 0}
            </span>
          ),
        }))
      : []),
  ];

  return (
    <div className="page-padding">
      <div className="flex">
        {/* left */}
        <div className="flex flex-col p-3">
          {/* date filter  */}
          <div className="p-2 pb-4 flex items-center">
            <label className="pr-2 text-xl text-brand-darkBlue">
              FILTER PAR
            </label>
            <SelectField
              placeholder="Selectioner"
              className="tw-filter-search-select"
              type="filter"
              onChange={(g) => setGroupBy(g)}
              options={[
                { label: 'Nom', value: 'name' },
                { label: 'Ville', value: 'city' },
                { label: 'Region', value: 'region' },
              ]}
              value={groupBy}
            />
          </div>
          <h3 className="text-brand-darkBlue text-2xl font-semibold">
            CONTACTS
          </h3>
          <div className="flex">
            <Table
              columns={actContactsColumns}
              data={positions}
              loading={loading}
            />
          </div>
          <h3 className="text-brand-darkBlue text-2xl font-semibold">
            SORTIE GOODIES
          </h3>
          <div className="flex">
            <Table
              columns={actProductsQuantityColumns}
              data={positions}
              loading={loading}
            />
          </div>
          <h3 className="text-brand-darkBlue text-2xl font-semibold">
            PRIX GOODIES
          </h3>
          <div className="flex">
            <Table
              columns={actProductsPriceColumns}
              data={positions}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
